import * as Cesium from "cesium";
import { create } from "zustand";

interface YellowEdgeState {
  // Define your state properties here
  feature?: Cesium.Cesium3DTileFeature;
  selectFeature: (features: Cesium.Cesium3DTileFeature) => void;
}

const useYellowEdgeStore = create<YellowEdgeState>((set) => {
  return {
    feature: undefined,
    selectFeature: (feature: Cesium.Cesium3DTileFeature) => {
      set({
        feature,
      });
    },
  };
});

export default useYellowEdgeStore;
